"use client";

import { Button, Modal, ModalBody, ModalHeader } from "flowbite-react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

interface ConfirmProps {
    message: string,
    yes: string,
    no: string,
    show: boolean
    onYes: () => void,
    onNo: () => void
}

export function ConfirmDialog({message, yes, no, onYes, onNo, show} : ConfirmProps) {
    return (
        <>
            <Modal show={show} size="md" onClose={onNo} popup>
                <ModalHeader />
                <ModalBody>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            { message }
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="secondary" onClick={onYes}>
                                { yes }
                            </Button>
                            <Button color="primary" onClick={onNo}>
                                { no }
                            </Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
}